import type { NextPage } from "next";
import Template from "@app/Template/Template";
import { HistoryScreen } from "@pages/history-screen";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const History: NextPage = () => {
    const TITLE = `Проверка авто по VIN и госномеру перед покупкой — ${PROJECT_NAME}`;
    const DESCRIPTION = `Проверьте историю автомобиля на ${PROJECT_NAME}: пробег, ДТП, ограничения, залоги и другие риски. Получите полный отчёт по VIN или госномеру за несколько секунд.`;
    const CANONICAL_URL = `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.HISTORY}`;

    return (
        <Template bgColor={"blue"}>
            <CustomHead
                title={TITLE}
                description={DESCRIPTION}
                robots={"index,follow"}
                canonical={CANONICAL_URL}
                openGraph={{
                    title: TITLE,
                    description: DESCRIPTION,
                    url: CANONICAL_URL,
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        alt: TITLE
                    }
                }}
            />
            <HistoryScreen />
        </Template>
    );
};

export default History;